export const ArticleType = {
  ACCESSORY: 'accessory',
  ARTICLE: 'article',
  SCOPE: 'scope'
};

export default ArticleType;
